import React from 'react';
import { Heart, Users, BookOpen, Sparkles } from 'lucide-react';

const items = [
  {
    icon: Heart,
    text: 'uvodno sprostitev, da se umiriš in pripraviš na povezovanje,',
  },
  {
    icon: BookOpen,
    text: 'teoretični del o pomenu dotika in komunikacije,',
  },
  {
    icon: Users,
    text: 'izmenjavo mnenj v krogu mamic, kjer ugotoviš, da v svojih izzivih nisi sama,',
  },
  {
    icon: Sparkles,
    text: 'posebne dodatke: rutino za lajšanje kolik in krčev, nežne raztezne vaje, pesmice in bibanke.',
  },
];

const MeetingsSection = () => (
  <section
    id="iaim-massage"
    className="relative overflow-hidden scroll-mt-20"
    data-testid="meetings-section"
  >
    {/* =========================================
        HERO – PRVI EKRAN
        ========================================= */}
    <div className="relative min-h-[calc(100vh-72px)] flex items-center overflow-hidden">

      {/* Mamica levo */}
      <img
        src="/icons/vd_hero_trebuscek_mama.png"
        alt=""
        aria-hidden="true"
        className="
          hidden md:block
          absolute
          left-[-2%] lg:left-[1%]
          bottom-[35px]
          w-[30rem] lg:w-[39rem]
          opacity-[0.24]
          pointer-events-none
          select-none
          z-0
        "
        data-testid="meetings-decor"
      />

      {/* Nežen sij */}
      <div
        aria-hidden="true"
        className="
          hidden md:block
          absolute
          left-[-5%]
          top-[5%]
          w-[38rem] lg:w-[46rem]
          h-[38rem] lg:h-[46rem]
          rounded-full
          pointer-events-none
          z-0
        "
        style={{
          background:
            'radial-gradient(ellipse at center, rgba(223,210,188,0.24) 0%, rgba(223,210,188,0.11) 48%, rgba(223,210,188,0.04) 68%, transparent 82%)',
          filter: 'blur(18px)',
        }}
      />

      {/* Hero besedilo */}
      <div className="relative z-10 w-full max-w-6xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="md:ml-[31%] lg:ml-[34%] text-center">

          <h3
            className="font-serif text-5xl sm:text-6xl lg:text-7xl text-violet-900 font-bold tracking-tight leading-[1.1] pt-2 mb-4"
            data-testid="meetings-eyebrow"
          >
            Masaža dojenčka IAIM
          </h3>

          <h2
            className="font-serif text-2xl sm:text-3xl text-stone-800 font-bold mb-5"
            data-testid="meetings-title"
          >
            Kako izgledajo naša srečanja
          </h2>

          <p className="text-stone-600 leading-relaxed max-w-2xl mx-auto">
            Predstavljaj si prostor, kjer ni hitenja. Kjer lahko dojenčka nahraniš, uspavaš ali samo držiš v naročju. Srečanja so namenjena mamicam z dojenčki od rojstva do prvega leta.
          </p>

        </div>
      </div>

      {/* Valovi spodaj */}
      <svg
        aria-hidden="true"
        viewBox="0 0 1440 130"
        preserveAspectRatio="none"
        className="absolute bottom-0 left-0 w-full h-[105px] lg:h-[125px] pointer-events-none z-[1]"
      >
        <path
          d="M-40 48 C150 6 290 104 485 55 C680 7 820 111 1015 61 C1200 15 1335 93 1480 48"
          fill="none"
          stroke="rgba(133,119,94,0.25)"
          strokeWidth="1.15"
        />
        <path
          d="M-40 72 C150 32 310 127 500 79 C690 31 840 126 1025 82 C1205 39 1340 114 1480 76"
          fill="none"
          stroke="rgba(133,119,94,0.17)"
          strokeWidth="1"
        />
        <path
          d="M-40 94 C155 58 315 142 510 101 C700 60 850 143 1040 104 C1220 67 1350 132 1480 99"
          fill="none"
          stroke="rgba(133,119,94,0.11)"
          strokeWidth="0.9"
        />
      </svg>
    </div>

    {/* =========================================
        VSEBINA – ŠELE PO SCROLLU
        ========================================= */}
    <div className="relative py-14 lg:py-20 overflow-hidden">

      {/* Ista grafika čez celoten spodnji del kot nežen obris */}
      <img
  src="/icons/vd_hero_trebuscek_mama.png"
  alt=""
  aria-hidden="true"
  className="
    absolute
    left-1/2
    top-1/2
    -translate-x-1/2
    -translate-y-1/2
    w-[38rem]
    md:w-[53rem]
    lg:w-[64rem]
    opacity-[0.045]
    pointer-events-none
    select-none
    z-0
  "
/>

      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">

        {/* Prostoročno narisan okvir */}
        <div className="relative mb-8 px-6 py-9 sm:px-9 lg:px-12 lg:py-11 bg-[#f4ede3]/88">

          <svg
            aria-hidden="true"
            viewBox="0 0 1000 560"
            preserveAspectRatio="none"
            className="absolute inset-0 w-full h-full pointer-events-none"
          >
            {/* glavna svinčnik črta */}
            <path
              d="
                M38 33
                C150 18, 292 30, 430 24
                C585 19, 731 28, 944 26
                C970 28, 980 46, 975 78
                C968 182, 980 290, 970 428
                C966 482, 954 516, 922 522
                C754 530, 614 518, 470 524
                C315 531, 173 517, 57 524
                C29 525, 20 500, 24 459
                C30 337, 16 223, 24 116
                C27 72, 24 44, 38 33
                Z
              "
              fill="none"
              stroke="rgba(111,91,65,0.42)"
              strokeWidth="1.7"
              strokeLinecap="round"
              strokeLinejoin="round"
            />

            {/* druga mehkejša črta */}
            <path
              d="
                M44 38
                C163 28, 304 34, 438 30
                C596 25, 747 35, 938 32
                C962 32, 972 50, 969 82
                C965 189, 976 296, 965 423
                C961 476, 950 508, 917 515
                C763 522, 612 513, 466 519
                C310 525, 179 512, 63 518
                C37 519, 28 495, 31 456
                C36 330, 24 222, 31 121
                C34 79, 31 48, 44 38
                Z
              "
              fill="none"
              stroke="rgba(111,91,65,0.15)"
              strokeWidth="1"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>

          <div className="relative z-10">
            <p className="text-stone-700 text-[15px] leading-relaxed mb-8 text-center">
              Program temelji na metodi, ki jo je razvila <span className="font-semibold">Vimala McClure</span> in poteka v <span className="font-semibold text-violet-900">petih srečanjih</span> (do 60 minut). Vsako srečanje poleg učenja masažnih gibov vključuje:
            </p>

            {/* seznam je zdaj posebej spodaj v naslednji vrstici */}
            <ul className="space-y-4">
              {items.map((it, i) => {
                const Icon = it.icon;
                return (
                  <li
                    key={i}
                    className="flex items-start gap-4 p-4 rounded-2xl bg-violet-100/26 hover:bg-violet-100/36 transition-colors"
                    data-testid={`meeting-item-${i}`}
                  >
                    <div className="flex-shrink-0 w-10 h-10 flex items-center justify-center">
  <Icon size={18} className="text-violet-800" />
</div>

                    <p className="text-stone-700 text-[15px] leading-relaxed pt-1.5">
                      {it.text}
                    </p>
                  </li>
                );
              })}
            </ul>
          </div>
        </div>

        {/* Obvestilo brez okvirja – nežna lila/vijola poteza kot čopič */}
        <div className="relative mt-4 px-6 py-8 sm:px-8 lg:px-12 text-center">
          <div
            aria-hidden="true"
            className="absolute inset-x-6 inset-y-3 rounded-[48px] bg-violet-200/32 blur-2xl"
          />
          <div
            aria-hidden="true"
            className="absolute left-[10%] right-[8%] top-[24%] bottom-[18%] rounded-[60px] bg-purple-200/20 blur-3xl rotate-[-1.5deg]"
          />
          <div
            aria-hidden="true"
            className="absolute left-[14%] right-[14%] top-[18%] bottom-[24%] rounded-[55px] bg-lilac-200/20 blur-[36px]"
          />

          <p className="relative z-10 text-stone-700 text-[15px] leading-relaxed max-w-4xl mx-auto">
            <span className="font-semibold">Ti masiraš svojega dojenčka,</span> jaz pa vse masažne prijeme prikazujem na lutki in jih večkrat ponovimo. Zato je skrb, da bi karkoli zamudila ali pozabila, <span className="italic">odveč</span>.
          </p>
        </div>

      </div>
    </div>
  </section>
);

export default MeetingsSection;